import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { ApiUrl } from '@/utils/constants';
import { ChatBotInfoResponse } from '@/types/api/mypage/chatBotInfo';

/** チャットボット顧客キー取得APIのURL */
const url = ApiUrl.Read.CHATBOT_KEY;

/**
 * チャットボット顧客キー取得APIの呼び出しフック。
 * マイページ内チャットを利用者ごとに識別するためのキーを取得する。
 *
 * @returns execute - API実行関数
 */
const useGetAPIChatBotKey = () => {
  const execute = useCallback(async (): Promise<AxiosResponse<ChatBotInfoResponse>> => {
    const headers = await getSigV4HeadersForGet(url);
    return api.get(url, headers);
  }, []);

  return { execute };
};

export default useGetAPIChatBotKey;
